
export default {
  props: { threeDUrl: { type: String, default: "" } },

  data: () => ({ showModal: false }),

  computed: {
    embedUrl() {
      return `${this.$config.augModalUrl}?sceneId=${this.threeDUrl}`;
    },
  },
};
